<template>
  <div class="video">
    <div class="video_nav">
     <div class="video_left">
        <div class="video_title">
          <div v-for="(item,index) in title" :key="index" class="video_txt" v-if="index<3" @click="dian(item.zt,item.id)">
            <div class="video_name" :class="item.zt?'addtxt':''">
              <div style="width: auto;display: inline-block;padding-bottom: 11px;" :class="item.zt?'xian':''">{{item.txt}}</div>
            </div>
            <div class="video_xian" v-if="index<1"></div>
          </div>
          <div class="video_right" @click="jumpduo">
            <div class="zi">MORE></div>
          </div>
        </div>
       <div class="video_nav2r" >
          <div class="video_list2" v-for="(item,index) in list" :key="index" v-if="index<3" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)" @click="jumpspxq(item.dataType,item.contentId,item.channelId,item.year,item.issue)">
            <div class="video_left1">
         <!--     <img src="/src/assets/tu5.jpg" alt="" v-if="item.titlePhoto==null"> -->
              <img :src="item.titlePhoto" alt="">
            </div>
            <div class="video_right1">
              <div class="video_txt1" :class="item.zt?'add1':''">{{item.title}}</div>
              <div class="video_txt2">{{item.content}}</div>
              <div class="video_txt3">{{item.addDate}}</div>
            </div>
          </div>
        </div>
        <div class="video_nav2r">
          <div class="video_list2" v-for="(item,index) in list" :key="index" v-if="index>2 && index<6" @mouseover="addtop(1,index)" @mouseout="addtop(2,index)"  @click="jumpspxq(item.dataType,item.contentId,item.channelId,item.year,item.issue)">
            <div class="video_left1">
<!--              <img src="/src/assets/tu5.jpg" alt="" v-if="item.titlePhoto==null"> -->
              <img :src="item.titlePhoto" alt="">
            </div>
            <div class="video_right1">
              <div class="video_txt1" :class="item.zt?'add1':''">{{item.title}}</div>
              <div class="video_txt2">{{item.content}}</div>
              <div class="video_txt3">{{item.addDate}}</div>
            </div>
          </div>
        </div>
      </div>
     <div class="video_right">
        <div class="express_rtitle">
          <div class="waike" style="width: auto;display: inline-block;padding-bottom: 11px;border-bottom: 3px solid var(--xt);">本刊信息</div>
        </div>
        <div class="txta">
          主   管：国家卫生健康委员会</br>

          主   办：中华预防医学会、福建医科大学</br>

          编   辑：中华高血压杂志编委会</br>

          出   版：福建医科大学附属第一医院中华高</br>

          血压杂志编辑部</br>

          主   编：胡大一</br>

          常务副主编：谢良地</br>

          编辑部主任：谢良地</br>

          编辑部副主任：苏津自、陈小明</br>

          ISSN：1673-7245</br>

          CN：11-5540/R</br>

          邮发代号：34-54</br>

          编辑部电话：0591-87982785
        </div>
      </div>
    </div>
  </div>
</template>

<script>

 export default {
  data () {
    return {
      num: 1,//1.视频/课件 2.病例分享 3.可添加栏目
      title:[
        {
          id: 1,
          txt: '视频/课件'
        },
        {
          id: 2,
          txt: '病例分享'
        }
      ],
      list: [],//列表数据
    }
  },methods:{
    //视频课件
    GetVideoCourseware(){
      var that = this;
      that.$httphelper.GetVideoCourseware({
        "journalId": that.$_JournalId,
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //文件下载
    GetContentFilePath(contentId,downType){
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": that.$_JournalId,
        "contentId": contentId,
        "downType": downType
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //病例分享
    GetHomePageBlockInfo(){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": that.$_JournalId,
        "pChannelId": 0,
        "channelId": 0,
        "jChannelID": 1468,
        "dataSourceType": 3,
        "dataShowType": 1,
        "curr": 1,
        "limit": 6,
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //初始化页面
    index(){
      this.GetVideoCourseware();
      for(var i=0;i<this.title.length;i++){
        if(i==0){
          this.title[i].zt = true;
          this.title.push('1');
          this.title.pop('1');
        }else{
          this.title[i].zt = false;
          this.title.push('1');
          this.title.pop('1');
        }
      }
    },
    jumpspxq(type,contentId,channelId,year,issue){
      if(this.num==1){
        if(type==1){
          this.$router.push({path:'/surgery_details',query:{contentId:contentId}});
        }else{
          //调取下载接口
          this.GetContentFilePath(contentId,2);
        }
      }else if(this.num==2){
        this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:contentId}});
      }
    },
    jumpduo(){
     if(this.num==1){
      this.$router.push({path:'/surgery'});
     }else if(this.num==2){
      this.$router.push({path:'/sharing'});
     }else if(this.num==3){

     }
    },
    //标题点击事件
    dian(zt,id){
      this.num = id;
      if(id==1){
        this.GetVideoCourseware();
      }else if(id==2){
        this.GetHomePageBlockInfo();
      }
      if(!zt){
        for(var i=0;i<this.title.length;i++){
          if(id==this.title[i].id){
            this.title[i].zt = true;
            this.title.push('1');
            this.title.pop('1');
          }else{
            this.title[i].zt = false;
            this.title.push('1');
            this.title.pop('1');
          }
        }
      }
    },
    //内容鼠标悬停
    addtop(num,index){
      if(num==1){
        for(var i=0;i<this.list.length;i++){
          if(index==i){
            this.list[i].zt = true;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      }else{
        for(var i=0;i<this.list.length;i++){
          this.list[i].zt = false;
          this.list.push('1');
          this.list.pop('1');
        }
      }
    }
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
.video{
    width: 100%;
    min-width: 1366px;
    .video_nav{
      width: 85%;
      margin: 0 auto;
      overflow: hidden;
      padding-top: 31px;
      padding-bottom: 21px;
      .video_left{
        width: 70%;
        float: left;
        position: relative;
        .shuxian{
          width: 10%;
          position: absolute;
          left: 0;
          top: 3px;
          .Journalism_xian1{
            width: 4px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 4px;
            margin-top: 7px;
          }
          .Journalism_xian2{
            width: 2px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 12px;
            margin-top: 7px;
          }
        }
        .video_title{
          width: 100%;
          height: 38px;
          border-bottom: 3px solid #DBDBDB;
          position: relative;
          margin-bottom: 30px;
          padding-bottom: 11px;
          .video_name{
            width: 100%;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            position: relative;
            .video_xian2{
              width: 100%;
              height: 3px;
              background-color: var(--biao);
              position: absolute;
              left: 0;
              bottom: -13px;
            }
          }
          .video_xian{
          	width: 4px;
          	height: 21px;
          	background: var(--xt);
            position: absolute;
            right: 0;
            top: 14px;
          }
          .video_txt{
        		width: 16%;
            cursor: pointer;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
        		position: relative;
            text-align: center;
            float: left;
            .video_xian{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
            	position: absolute;
            	right: 0;
              top: 14px;
            }
          }
          .video_txt:first-child{
            width: 13%;
            text-align: left;
          }
          .video_right{
          	float: right;
          	width: 90px;
          	height: 12px;
          	font-size: 14px;
          	font-family: Source Han Sans SC;
          	font-weight: bold;
          	color: #878787;
          	line-height: 23px;
            cursor: pointer;
            text-align: right;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
          }
        }
        .video_nav2r{
          width: 50%;
          float: left;
          overflow: hidden;
          padding-bottom: 30px;
          .video_list2{
            width: 100%;
            overflow: hidden;
            margin-bottom: 25px;
            cursor: pointer;
            .video_left1{
              width: 170px;
              height: 120px;
              float: left;
              margin-right: 2.5%;
              img{
                width: 100%;
                height: 120px;
                object-fit: cover;
              }
              img:hover{
                transform: scale(1.05);
              }
            }
            .video_right1{
              width: 59%;
              float: left;
              .video_txt1{
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: bold;
                color: #000000;
                margin-top: 5px;
                margin-bottom: 8px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
              .video_txt2,.video_txt3{
                font-size: 14px;
                font-family: Source Han Sans SC;
                font-weight: 400;
                color: #474747;
              }
              .video_txt2{
                margin-bottom: 10px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
              }
            }
          }
        }
      }
      .video_right{
        width: 28%;
        float: left;
        padding-left: 2%;
        background-color: #FFFFFF;
        .express_rtitle{
          width: 90%;
          margin: 0 auto;
          overflow: hidden;
          border-bottom: 3px solid #DBDBDB;
          position: relative;
          .waike{
            width: 50%;
            float: left;
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            line-height: 38px;
          }
          .zi{
            width: 50%;
            float: right;
            text-align: right;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 38px;
            cursor: pointer;
          }
          .waixian{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 81px;
            height: 3px;
            background: var(--biao);
          }
        }
        .txta{
          width: 90%;
          margin: 0 auto;
          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #000000;
          line-height: 28px;
          margin-top: 31px;
        }
      }
    }
}

@media only screen and (min-width: 1200px) {
  .video{
    .video_nav{
      .video_left{
        .video_nav2r{
          .video_list2{
            .video_left1{
              width: 145px!important;
            }
          }
        }
      }
    }
  }
}

.add1{
  color: var(--xt)!important;
  text-decoration: underline;
}
.addtxt{
  font-weight: bold!important;  font-size: 20px!important;
}
.xian{
  border-bottom: 3px solid var(--xt)!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/video.vue